import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './MainSearchSnippetsContainer';
import { LegislationSnippet } from './legislation/LegislationSnippet';
import { SearchCommentarySnippet } from './commentary/SearchCommentarySnippet';
import styles from './main_search_snippets.module.scss';

type Props = PropsFromRedux;

export const RawMainSearchSnippets: FC<Props> = ({
  legislationSnippet,
  commentariesSnippet,
  originalQueryKey,
}) => {
  return (
    <div className={styles.wrapper}>
      {!!legislationSnippet && (
        <LegislationSnippet
          originalQueryKey={originalQueryKey}
          legislation={legislationSnippet}
        />
      )}

      {!!commentariesSnippet && (
        <SearchCommentarySnippet commentaries={commentariesSnippet} />
      )}
    </div>
  );
};
export const MainSearchSnippets = Connect(RawMainSearchSnippets);
